import { Navigate, useNavigate } from "react-router-dom";
import { GfgButton } from "@/components/ui";
import {
  CAMPAIGN_BUILDER_BLOCKED_TEXT,
  CAMPAIGN_EDIT_BLOCKED_TEXT,
} from "@/constants/campaignBuilder";
import { usePermissions } from "@/hooks/usePermissions";

/**
 * Shown in place of the Campaign Builder to a client whose role can't create campaigns (View Only)
 * who opened its URL directly, so they learn why rather than landing on the Dashboard. GFG staff
 * who aren't impersonating keep the plain redirect: the builder is a client surface. `campaign`:
 * the role can build, but the campaign opened is in a group where the caller is View Only.
 */
export default function CampaignBuilderBlocked({
  reason = "role",
}: {
  reason?: "role" | "campaign";
}) {
  const { isGfg } = usePermissions();
  const navigate = useNavigate();
  if (isGfg) return <Navigate to="/dashboard" replace />;

  const text = reason === "campaign" ? CAMPAIGN_EDIT_BLOCKED_TEXT : CAMPAIGN_BUILDER_BLOCKED_TEXT;
  const back = reason === "campaign" ? "/campaigns" : "/dashboard";

  return (
    <div
      role="alert"
      className="flex min-h-[70vh] flex-col items-center justify-center gap-3 px-6 text-center"
    >
      <h1 className="m-0 font-crimson text-[26px] font-normal text-rodeo-black">{text.title}</h1>
      <p className="m-0 max-w-[460px] text-[15px] text-graphite">{text.body}</p>
      <GfgButton variant="outline" className="mt-2" onClick={() => navigate(back)}>
        {text.action}
      </GfgButton>
    </div>
  );
}
